import React from 'react'

const ProductsMenu = () => {
  return (
    <div className='FadeIn'>ProductsMenu</div>
  )
}

export default ProductsMenu